import { Wallet, WalletId } from '@/api/wallets/types';
import { ApiTransactionAPIModel } from '@/generated/api/fps/core';
import { MoneyType } from '@/model/common';

export type { Wallet, WalletId };

export const NAMESPACE = 'WALLET';

export enum WalletUIState {
  TRANSACTION = 'transaction',
  TRANSACTIONS = 'transactions',
}

export interface Transaction extends Omit<ApiTransactionAPIModel, 'amount' | 'accountFromFee' | 'accountToFee'> {
  amount: MoneyType;
  accountFromFee: MoneyType;
  accountToFee: MoneyType;
}

export enum TransactionPeriod {
  lastWeek = 'lastWeek',
  lastMonth = 'lastMonth',
  last3Month = 'last3Month',
  custom = 'custom'
}

export interface TransactionsPeriod {
  type: TransactionPeriod;
}

export interface LastWeekTransactionsPeriod extends TransactionsPeriod {
  type: TransactionPeriod.lastWeek;
}

export interface LastMonthTransactionsPeriod extends TransactionsPeriod {
  type: TransactionPeriod.lastMonth;
}

export interface Last3MonthTransactionsPeriod extends TransactionsPeriod {
  type: TransactionPeriod.last3Month;
}

export interface CustomTransactionsPeriod extends TransactionsPeriod {
  type: TransactionPeriod.custom;
  dateFrom: Date;
  dateTo: Date;
}

export type AnyTransactionPeriod =
  LastWeekTransactionsPeriod
  | LastMonthTransactionsPeriod
  | Last3MonthTransactionsPeriod
  | CustomTransactionsPeriod;

export interface State {
  initialized: boolean;
  transactions?: {
    hasMore: boolean;
    data: Transaction[];
    lastPage: number;
  };
  transactionsFilter: AnyTransactionPeriod,
  wallets: Wallet[];
  selectedWallet?: WalletId,
  lastReload: {
    balance?: Date;
    transactions?: Date;
  };
}

export const initialState: State = {
  initialized: false,
  transactionsFilter: { type: TransactionPeriod.lastWeek },
  selectedWallet: undefined,
  wallets: [],
  lastReload: { balance: new Date() },
};
